import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "graphUpFilled"
const GraphUpFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.75 3H21C21.828 3 22.5 3.672 22.5 4.5V16.5C22.5 17.328 21.828 18 21 18H12.75V21H15V22.5H9V21H11.25V18H3C2.172 18 1.5 17.328 1.5 16.5V4.5C1.5 3.672 2.172 3 3 3H11.25V1.5H12.75zM20.057 8.123C19.78 7.815 19.307 7.791 18.998 8.068L15.743 10.997 12.743 8.372 8.98 11.758 7.231 10.298 6.773 9.92 4.8 11.4C4.47 11.65 4.402 12.118 4.65 12.45 4.9 12.78 5.368 12.848 5.7 12.6L6.724 11.83 8.52 13.327 9.019 13.742 12.757 10.378 15.757 13.003 20.002 9.183C20.31 8.904 20.334 8.43 20.057 8.122"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GraphUpFilledIcon
